import React from "react";
import { Shield, FileText, Landmark, Lock, Database, Info } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const privacyDetails = [{
  title: "Hosting & Infrastruktur",
  description: "Betrieb über 10Web auf zertifizierten Google Cloud Servern in Frankfurt. Nutzung von Cloudflare und AWS (S3). Alle Partner sind nach dem EU-US Data Privacy Framework zertifiziert.",
  icon: Database
}, {
  title: "Datenerfassung",
  description: "Technisch notwendige Server-Log-Daten (IP, Zeitstempel) werden zur Sicherheit und Stabilität gemäß Art. 6 Abs. 1 lit. f DSGVO erfasst.",
  icon: Lock
}, {
  title: "Ihre Rechte",
  description: "Sie haben das Recht auf Auskunft, Berichtigung und Löschung Ihrer Daten sowie ein Beschwerderecht beim LfDI Rheinland-Pfalz.",
  icon: Info
}, {
  title: "Schweigepflicht",
  description: "Alle Informationen unterliegen der gesetzlichen Schweigepflicht gemäß § 203 StGB und werden mit höchster Diskretion behandelt.",
  icon: Shield
}, {
  title: "Aufbewahrungspflicht",
  description: "Patientenakten werden gemäß § 630f BGB für mindestens 10 Jahre nach Abschluss der Behandlung sicher verwahrt.",
  icon: FileText
}, {
  title: "Datensparsamkeit",
  description: "Wir verzichten auf Analyse-Tools und Tracking-Cookies. Ein Cookie-Banner ist daher auf dieser Website nicht erforderlich.",
  icon: Landmark
}];
export default function DatenschutzInformationen() {
  return <section id="datenschutz-details" className="relative bg-background py-24 overflow-hidden">
      <div className="absolute inset-0 bg-accent/20 pointer-events-none" aria-hidden="true" />
      
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="mb-16">
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl text-foreground leading-tight tracking-wider">
              Datenschutz & <br />
              <span className="heading-italic">Vertrauen</span>
            </h2>
            
            <div className="mt-8 p-6 bg-card/50 rounded-2xl border border-border/40 inline-block">
              <h3 className="text-sm uppercase tracking-widest text-primary font-bold mb-2">Verantwortliche Stelle</h3>
              <p className="text-muted-foreground font-sans leading-relaxed text-sm">
                Psychologische Praxis Soonwald • Claudia Christ • Struthof 1 • 55595 Münchwald<br />
                E-Mail: post@claudiachrist.de
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {privacyDetails.map((detail, i) => {
            const Icon = detail.icon;
            return <Card key={i} className="bg-card hover:bg-accent/5 transition-colors border-border/40 shadow-sm rounded-2xl">
                  <CardContent className="p-6">
                    <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                      <Icon className="w-5 h-5 text-primary" />
                    </div>
                    <h5 className="font-default text-lg font-semibold text-foreground mb-2">
                      {detail.title}
                    </h5>
                    <p className="text-sm text-muted-foreground font-sans leading-relaxed">
                      {detail.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>

          <div className="mt-12 pt-8 border-t border-border/40 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <p className="text-xs text-muted-foreground font-sans italic">
              Aufsichtsbehörde: Gesundheitsamt Bad Kreuznach. Alle Datenübertragungen erfolgen verschlüsselt (SSL/TLS).
            </p>
          </div>
        </div>
      </div>
    </section>;
}